import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const InlinePageHeader = ({
  page,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
      <div className="relative mb-fluid-8">
        {page.bannerMedia || props.isPreview ? (
          <HeaderBanner
            media={page?.bannerMedia}
            className="shadow-page-widget absolute size-full rounded-page-widget"
            {...props}
          >
            <div className="absolute left-0 top-0 size-full bg-background/50" />
          </HeaderBanner>
        ) : (
          <div className="absolute size-full"></div>
        )}

        <div className="relative flex flex-row items-center space-x-fluid-6 p-fluid-4">
          <div className="flex">
            <HeaderLogo
              media={page?.logoMedia}
              {...props}
              className="shadow-page-widget rounded-page-widget"
              sizeClassName="size-fluid-20"
              size={80}
            />
          </div>

          <div className="flex flex-col space-y-fluid-3">
            <HeaderName
              name={page?.name}
              className="line-clamp-2 text-fluid-lg text-black"
              {...props}
            />

            <HeaderDescription
              description={page?.description}
              className="line-clamp-3 text-fluid-sm text-black"
              {...props}
            />

            <HeaderSocialIcons
              socialIcons={page?.socialIcons}
              className="text-black"
              sizeClassName="size-fluid-7"
              {...props}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
